import { WorkflowSettingsPopupSectionProps } from '../../WorkflowSettingsPopupContent.types';

export interface SectionDearPORejectedNoteToMemoProps extends WorkflowSettingsPopupSectionProps {}

export enum RejectedNoteOption {
    True = 'True',
    False = 'False',
}
